import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BodyS } from '@sorare/core/src/atoms/typography';
import { Card } from '@sorare/core/src/components/card/Card';
import { CardDescriptionFromProps } from '@sorare/core/src/components/token/CardDescriptionFromProps';
import { format } from '@sorare/core/src/lib/seasons';

import { Team } from 'components/Team';

import { CommonCardSummary_composeTeamBenchObjectInterface } from './__generated__/index.graphql';

const Summary = styled(Vertical).attrs({ gap: 2 })``;

const Image = styled.div`
  flex-shrink: 0;
  width: 52px;
`;

const Metas = styled.div`
  flex-grow: 1;
`;

type Props = {
  commonPlayer: CommonCardSummary_composeTeamBenchObjectInterface & {
    __typename: 'ComposeTeamBenchCommonPlayer';
  };
};

export const CommonCardSummary = ({ commonPlayer }: Props) => {
  return (
    <Summary>
      <Horizontal gap={1.5}>
        <Image>
          <Card card={commonPlayer} />
        </Image>
        <Metas>
          <CardDescriptionFromProps
            path={null}
            displayName={commonPlayer.anyPlayer.displayName}
            description={`${format(2024)} - Common`}
            withoutLink
            Title={BodyM}
            titleColor="var(--c-white)"
            Details={BodyS}
            detailsColor="var(--c-nd-600)"
          />
          <Team card={commonPlayer} />
        </Metas>
      </Horizontal>
    </Summary>
  );
};

CommonCardSummary.fragments = {
  composeTeamBenchObjectInterface: gql`
    fragment CommonCardSummary_composeTeamBenchObjectInterface on ComposeTeamBenchObjectInterface {
      id
      anyPlayer {
        slug
        displayName
        ...Team_anyPlayerInterface
      }
      ...Card_composeTeamBenchObjectInterface
    }
    ${Card.fragments.composeTeamBenchObjectInterface}
    ${Team.fragments.anyPlayerInterface}
  ` as TypedDocumentNode<CommonCardSummary_composeTeamBenchObjectInterface>,
};
